export const baseURL = process.env.REACT_APP_BASE_URL;
export const secretKey = process.env.REACT_APP_SECRET_KEY;

export const agoraId = process.env.REACT_APP_AGORA_ID;

// Subdomain routing - editable via .env
export const subdomainAdmin = process.env.REACT_APP_SUBDOMAIN_ADMIN || "admin";
export const subdomainContentCreator = process.env.REACT_APP_SUBDOMAIN_CONTENT_CREATOR || "content-creator";
export const subdomainSubscription = process.env.REACT_APP_SUBDOMAIN_SUBSCRIPTION || "subscription";

// Subscription subdomain API (same backend as admin)
const subscriptionApiBase = (baseURL || "").replace(/\/$/, "");
export const subscriptionApi = {
  parseUrl: `${subscriptionApiBase}/subscription/parse-url`,
  getPlans: (country) =>
    country
      ? `${subscriptionApiBase}/subscription/plans?country=${encodeURIComponent(country)}`
      : `${subscriptionApiBase}/subscription/plans`,
  checkout: `${subscriptionApiBase}/subscription/checkout`,
  createFreeSubscription: `${subscriptionApiBase}/subscription/create-free-subscription`,
};
